import { UserInterface } from 'shared/types/user-interface'
import { hasWorkspaces } from './has-workspaces'

// Plan of the workspace the user is currently acting in: their own plan as the owner, the owner's
// plan when switched into someone else's workspace (Workspace Admin / Assistant).
export const getWorkspaceOwnerUserPlanId = (user: UserInterface): number | null => {
  if (user.workspaceOwner === null) {
    return user.userPlanId
  }

  if (!hasWorkspaces(user)) {
    return null
  }

  const membership = user.workspaceMemberships.find(
    el => el.workspaceOwner.id === user.workspaceOwner,
  )

  return membership?.workspaceOwner.userPlanId ?? null
}
